import { t } from '@i18n';
import { formatDate } from '@utils';
import { PendingProspect } from '../data/useGetPendingProspects';

type DetailItem = {
  label: string;
  getText: (prospect: PendingProspect) => string | null | undefined;
};

/**
 * Fields from the pending prospects list endpoint for the detail screen
 */
export const DETAIL_ITEMS: DetailItem[] = [
  {
    label: 'PENDING_PROSPECTS:DETAIL:ID',
    getText: (prospect) => prospect.id,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:CUSTOMER_NAME',
    getText: (prospect) => prospect.customerName,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:CUSTOMER_ID',
    getText: (prospect) =>
      prospect.customerId !== null && prospect.customerId !== undefined
        ? String(prospect.customerId)
        : null,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:COMPANY_CUIT',
    getText: (prospect) => prospect.companyCuit,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:SEGMENT_NAME',
    getText: (prospect) => prospect.segmentName,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:USERS_COUNT',
    getText: (prospect) =>
      prospect.usersCount !== null && prospect.usersCount !== undefined
        ? String(prospect.usersCount)
        : null,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:FILE_NAME',
    getText: (prospect) => prospect.fileName,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:FILE_PATH',
    getText: (prospect) => prospect.filePath,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:STATUS',
    getText: (prospect) =>
      prospect.status ? t(`PENDING_PROSPECTS:STATUS:${prospect.status}`) : null,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:CREATED_BY',
    getText: (prospect) => prospect.createdBy,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:CREATED_AT',
    getText: (prospect) => (prospect.createdAt ? formatDate(prospect.createdAt) : null),
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:UPDATED_AT',
    getText: (prospect) => (prospect.updatedAt ? formatDate(prospect.updatedAt) : null),
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:RESOLVED_BY',
    getText: (prospect) => prospect.resolvedBy,
  },
  {
    label: 'PENDING_PROSPECTS:DETAIL:RESOLVED_AT',
    getText: (prospect) => (prospect.resolvedAt ? formatDate(prospect.resolvedAt) : null),
  },
];
